export const baseModalTitles = {
  baseModalTitleProfileUser: "Profile User",
  baseModalTitleMobilePayment: "Mobile Payment",
  baseModalTitleInviteFriend: "Invite Friend",
  baseModalTitleChangePassword: "Change Password",
  baseModalTitleWithdrawal: "Withdrawal",
  baseModalTitleTransfer: "Transfer Money",
  baseModalTitleRegistration: "Sign Up and Win!",
  baseModalTitleSupport: "Support",
};
